// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"NJ","modalContent":"OJ","header":"PJ","close":"QJ"};